import { FacebookFilled, InstagramFilled, YoutubeFilled } from '@ant-design/icons';
import { useStore } from '@tanstack/react-store';
import React from 'react';
import { data } from '~/data/basic';
import { langStore } from '~/store/langStore';

interface SocialLinksProps {
  className?: string;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ className }) => {
  const locale = useStore(langStore, s => s);

  return (
    <div className={`hidden items-center md:flex ${className}`}>
      <div className="relative mr-6 md:mr-10">
        <h3 className="text-red origin-bottom-left -rotate-3 transform text-lg font-bold whitespace-nowrap md:text-xl">
          {data.artists.follow[locale].toUpperCase()}
          !
        </h3>
        {/* Simplified arrow, consider SVG for a closer match to the image */}
        <div
          aria-hidden="true"
          className="text-red absolute -right-6 -bottom-3 scale-y-90 -rotate-[75deg] transform text-5xl font-light md:-right-8 md:-bottom-4"
          style={{ fontFamily: 'serif' }} // Serif font for a slightly more curved arrow
        >
          ⤷
        </div>
      </div>
      <div className="bg-red flex flex-col space-y-1.5 rounded-md p-2 shadow-md">
        <a
          href="#"
          aria-label="YouTube"
          className="text-white transition-opacity hover:opacity-80"
        >
          <YoutubeFilled />
        </a>
        <a
          href="#"
          aria-label="Facebook"
          className="text-white transition-opacity hover:opacity-80"
        >
          <FacebookFilled />
        </a>
        <a
          href="#"
          aria-label="Instagram"
          className="text-white transition-opacity hover:opacity-80"
        >
          <InstagramFilled />
        </a>
      </div>
    </div>
  );
};

export default SocialLinks;
